import { render } from "./Header.vue?vue&type=template&id=895af380&scoped=true"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=895af380&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-895af380"]])

export default __exports__